<template>
    <v-container class="containerFillHeight" fluid>
      <v-row no-gutters class="">
        <div class=" w-full">
          <v-card dark color="black" class="!rounded-[15px] h-[calc(100vh-150px)] overflow-auto animate-pulse">
            <v-card-title class="justify-center py-6 text-center">
              <h4 class="" :class="`${routeLink}_fortext`">FAQs</h4>
            </v-card-title>
            <v-card-text>
              <v-expansion-panels dark inset >
                <v-expansion-panel
                class="bg-gradient-to-b from-black to-transparent"
                  v-for="(item, i) in fetchSettings"
                  :key="item.id"
                >
                  <v-expansion-panel-header>
                    {{ item.title }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    {{ item.text }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </div>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "FAQ",
    data() {
      return {};
    },
    computed: {
      fetchSettings() {
        if (this.$store.getters.getSettings) {
          return this.$store.getters.getSettings;
        } else {
          this.$store.dispatch("GetSettings");
          return this.$store.getters.getSettings;
        }
      },
    },
    methods: {},
    created() {},
  };
  </script>
  
  <style scoped>
  
  .straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(335deg,
        rgb(136 97 0) 0%,
        rgb(255 223 153) 53%,
        rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  .gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(357deg,
        rgba(0, 240, 255, 1) 55%,
        rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  .lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
        rgba(126, 0, 157, 0.9416141456582633) 2%,
        rgba(161, 51, 246, 1) 45%,
        rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  </style>
  